import React, { useState, useRef, useEffect } from "react";
import { Checkbox, Input, Space, Button } from "antd";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteComponent";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SearchOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";

const TableTopActions = (props) => {
  const { branchId } = useParams();
  const {
    newAction,
    selectionAction,
    keys,
    entity,
    textFilter,
    onTextChange,
    onStaffInchargeChange,
  } = props;
  const [size, setSize] = useState("large"); // default is 'middle'
  const [showInactive, setShowInactive] = useState(false);

  const intl = useIntl();
  const headerInputRef = useRef();

  useEffect(() => {
    if (headerInputRef && headerInputRef.current) {
      const { input } = headerInputRef.current;
      input.focus();
    }
  }, [headerInputRef]);

  const staffFilter = {
    filter: {
      $and: [
        { staff_member: true },
        {
          $or: showInactive ? [{ status: 1 }, { status: 2 }] : [{ status: 1 }],
        },
      ],
    },
  };

  const onShowInactiveChange = (e) => {
    setShowInactive(e.target.checked);
  };

  const showOwner = false;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: "10px",
      }}
    >
      <div>
        <Space direction="horizontal">
          <Input
            prefix={
              <SearchOutlined style={{ padding: "0  5px", opacity: 0.4 }} />
            }
            placeholder={intl.formatMessage({
              id: `app.${entity}.search_for_record`,
            })}
            value={textFilter}
            onChange={onTextChange}
            style={{ width: 300 }}
            size="large"
            allowClear
            ref={headerInputRef}
          />
          <EmployeesSelect
            size="large"
            placeholder={intl.formatMessage({
              id: `app.gaps.search_by_staff`,
            })}
            style={{ width: 150 }}
            onChange={onStaffInchargeChange}
            allowClear
            extraParams={{
              ...staffFilter,
              scopePrefix: branchId ? `branches/${branchId}/` : ``,
            }}
          />

          <Checkbox
            style={{ margin: "0 20px" }}
            onChange={onShowInactiveChange}
            checked={showInactive}
          >
            {intl.formatMessage({
              id: `app.actions.include_inactive`,
            })}
          </Checkbox>
        </Space>
      </div>

      <Space wrap>
        <Button type="primary" onClick={() => newAction(null, "new")}>
          {" "}
          {intl.formatMessage({
            id: `app.${entity}.new_record`,
          })}
        </Button>
        {entity !== "campaigns" && (
          <Button
            onClick={() => selectionAction("add_to_campaign")}
            disabled={keys.length === 0}
          >
            {" "}
            {intl.formatMessage({
              id: `app.${entity}.add_to_campaign`,
            })}
          </Button>
        )}
        {showOwner && (
          <Button
            onClick={() => selectionAction("change_owner")}
            disabled={keys.length === 0}
          >
            {" "}
            {intl.formatMessage({
              id: `app.${entity}.change_owner`,
            })}
          </Button>
        )}

        <Button
          onClick={() => selectionAction("change_assigned_user")}
          disabled={keys.length === 0}
        >
          {" "}
          {intl.formatMessage({
            id: `app.${entity}.change_assigned_user`,
          })}
        </Button>
      </Space>
    </div>
  );
};
export default TableTopActions;
